export default __webpack_public_path__ + "eye-closed.cfa671aa.svg";